/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ArtistSourceIdUpdate
 */
export interface ArtistSourceIdUpdate {
    /**
     * 
     * @type {boolean}
     * @memberof ArtistSourceIdUpdate
     */
    valid: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ArtistSourceIdUpdate
     */
    rejected?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ArtistSourceIdUpdate
     */
    approved?: boolean;
}

/**
 * Check if a given object implements the ArtistSourceIdUpdate interface.
 */
export function instanceOfArtistSourceIdUpdate(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "valid" in value;

    return isInstance;
}

export function ArtistSourceIdUpdateFromJSON(json: any): ArtistSourceIdUpdate {
    return ArtistSourceIdUpdateFromJSONTyped(json, false);
}

export function ArtistSourceIdUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArtistSourceIdUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'valid': json['valid'],
        'rejected': !exists(json, 'rejected') ? undefined : json['rejected'],
        'approved': !exists(json, 'approved') ? undefined : json['approved'],
    };
}

export function ArtistSourceIdUpdateToJSON(value?: ArtistSourceIdUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'valid': value.valid,
        'rejected': value.rejected,
        'approved': value.approved,
    };
}

